import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const CustomPhoneInput = ({ phone, handlePhoneChange }) => {
  return (
    <>
      <style jsx global>{`
        .custom-phone-input .PhoneInputInput:focus {
          outline: none;
          box-shadow: none;
        }
      `}</style>
      <PhoneInput
        required
        placeholder="Enter your phone number"
        className="w-full p-2 text-sm border-none rounded-md custom-phone-input"
        international
        defaultCountry="GB"
        value={phone}
        onChange={handlePhoneChange}
      />
    </>
  );
};

export default CustomPhoneInput;
